import styled from 'styled-components';

export const Wrapper = styled.div`
	cursor: pointer;
	visibility: hidden;

	svg {
		transition: none;
	}
`;
